var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70752 2.70703V6.87837C1.70746 7.40866 1.918 7.91727 2.29285 8.29237L10.0002 16.0004C10.3907 16.3907 11.0237 16.3907 11.4142 16.0004L16.0002 11.4137C16.3906 11.0232 16.3906 10.3902 16.0002 9.9997L8.29285 2.29236C7.91776 1.91751 7.40915 1.70697 6.87885 1.70703H2.70752C2.15523 1.70703 1.70752 2.15475 1.70752 2.70703Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20752 6.20703C5.7598 6.20703 6.20752 5.75932 6.20752 5.20703C6.20752 4.65475 5.7598 4.20703 5.20752 4.20703C4.65523 4.20703 4.20752 4.65475 4.20752 5.20703C4.20752 5.75932 4.65523 6.20703 5.20752 6.20703Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.729a676ef1d3aadacdd1ceeff0df3146.svg";
export { ForwardRef as ReactComponent };